import { useQueryClient, useQuery } from 'react-query';
import API from '../const.js';
import { QueryNames } from './queryNames.js';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { GET_USER_BID_TYPES } from '../constants/index.js';

function useGetLorryInfo({ lorryId, companyId }, queryOptions) {
    const queryClient = useQueryClient();
    return useQuery([QueryNames.userLorries.getLorryInfoById, lorryId], () => fetch(API.USER_LORRY_INFO_BY_ID + getAuthIdParam(companyId) + `&l_i=${lorryId}&n_i=0`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    })
        .then((res) => {
        if (res.ok) {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
        else {
            if (res.status === 401)
                queryClient.invalidateQueries();
            throw new Error("LoadInfo API failed");
        }
    })
        .catch((error) => {
        throw new Error(error);
    }), Object.assign(Object.assign({}, queryOptions), { enabled: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.enabled, onError: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.onError }));
}
function useGetLorryBidsService({ lorryId, companyId, type }, queryOptions) {
    const queryClient = useQueryClient();
    return useQuery([QueryNames.userLorries.getLorryBidsById, lorryId, type], () => fetch((type === GET_USER_BID_TYPES.RECEIVED
        ? API.USER_LORRY_RECEIVED_BIDS_BY_ID
        : API.USER_LORRY_SENT_BIDS_BY_ID) +
        getAuthIdParam() +
        `&l_i=${lorryId}&c_i=${companyId}&preload=company_details&preload=load_details&preload=lorry_details`, {
        method: "GET",
        headers: Object.assign({ Accept: "application/json", "Content-Type": "application/json" }, getAuthHeader())
    })
        .then((res) => {
        if (res.ok) {
            return res.json().then((jsonData) => {
                const allData = jsonData.data;
                return allData;
            });
        }
        else {
            if (res.status === 401)
                queryClient.invalidateQueries();
            throw new Error("LoadInfo API failed");
        }
    })
        .catch((error) => {
        throw new Error(error);
    }), {
        enabled: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.enabled,
        onError: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.onError,
        select: queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.select
    });
}

export { useGetLorryBidsService, useGetLorryInfo };
//# sourceMappingURL=useLoadLorryService.js.map
